import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {GuestPicker} from '@homeaway/react-guest-picker';
import {SVGIcon} from '@homeaway/react-svg';
import {GROUP__16} from '@homeaway/svg-defs/lib/defs/GROUP__16';
import {withTranslationsAsProps} from '../../../components/translations';

class GuestPickerContainer extends Component {
    static propTypes = {
        petIncluded: PropTypes.bool,
        childrenCount: PropTypes.number,
        adultsCount: PropTypes.number,
        onGuestsClick: PropTypes.func,
        onNewGuests: PropTypes.func
    }

    static defaultProps = {
        onGuestsClick: () => {},
        onNewGuests: () => {}
    }

    constructor(props) {
        super(props);
        this.state = {
            adultsCount: props.adultsCount || 2,
            childrenCount: props.childrenCount || 0,
            petIncluded: props.petsIncluded || false
        };
    }

    handleGuestSelectorChanged = (key, value) => {
        this.setState({[key]: value});
    }

    handleGuestSelectorExited = (undoState) => {
        this.setState(undoState);
        return;
    }

    handleGuestSelectorClose = () => {
        if (this.isGuestChange()) {
            this.props.onNewGuests(this.state.adultsCount, this.state.childrenCount, this.state.petIncluded, this.props.startDate, this.props.endDate);
        }
    }

    isGuestChange = () => {
        return this.state.adultsCount !== this.props.adultsCount || this.state.childrenCount !== this.props.childrenCount || this.state.petIncluded !== this.props.petIncluded ;
    }

    guestLabel = (numGuests, pet) => {
        let petString = pet ? `, ${this.props.petsLabel}` : '';
        return numGuests ? `${numGuests} ${this.props.guestsLabel}${petString}` : '';
    }

    render() {
        const {
            guestTitle,
            adultLabel,
            adultsLabel,
            childLabel,
            childrenLabel,
            petsLabel,
            yesLabel,
            noLabel,
            clearLabel,
            applyLabel,
            modalTitle,
            guestContinueLabel,
            petMessage,
            onGuestsClick
        } = this.props;

        const {adultsCount, childrenCount, petIncluded} = this.state;
        let adultsLabelFormatted = (adultsCount === 1) ? `${adultsCount} ${adultLabel}` : `${adultsCount} ${adultsLabel}`;
        let childrenLabelFormatted = (childrenCount === 1) ? `${childrenCount} ${childLabel}` : `${childrenCount} ${childrenLabel}`;
        return (
            <form>
                <GuestPicker
                    adultsMin = {1}
                    applyButtonLabel = {applyLabel}
                    label = {guestTitle}
                    name = {guestTitle}
                    guestLabel = {this.guestLabel(adultsCount + childrenCount, petIncluded)}
                    adultsLabel = {adultsLabelFormatted}
                    adultsCount = {adultsCount}
                    childrenLabel = {childrenLabelFormatted}
                    childrenCount = {childrenCount}
                    clearButtonLabel = {clearLabel}
                    continueButtonLabel = {guestContinueLabel}
                    inputIcon = {<SVGIcon markup={GROUP__16}/>}
                    modalTitle = {modalTitle}
                    petIncluded = {petIncluded}
                    petLabel = {petsLabel}
                    petMessage = {petMessage}
                    petNoLabel = {noLabel}
                    petYesLabel = {yesLabel}
                    showPetOption
                    onChange= {this.handleGuestSelectorChanged}
                    onClose = {this.handleGuestSelectorClose}
                    onExit = {this.handleGuestSelectorExited}
                    onOpen = {onGuestsClick}
                    showClearButton ={false}
                />
            </form>
        );
    }
}

export default withTranslationsAsProps({
    'guest.selector.title': 'guestTitle',
    'guest.selector.adult': 'adultLabel',
    'guest.selector.adults': 'adultsLabel',
    'guest.selector.child': 'childLabel',
    'guest.selector.children': 'childrenLabel',
    'guest.selector.pets': 'petsLabel',
    'guest.selector.guest': 'guestLabel',
    'guest.selector.guests': 'guestsLabel',
    'guest.selector.pets.yes': 'yesLabel',
    'guest.selector.pets.no': 'noLabel',
    'guest.selector.clear': 'clearLabel',
    'guest.selector.apply': 'applyLabel',
    'guest.modal.title': 'modalTitle',
    'guest.modal.continue': 'guestContinueLabel',
    'guest.modal.petmessage': 'petMessage',
})(GuestPickerContainer);



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/guest-picker.js